const $ = window.$;



export default class Wave {
  constructor(type) {
    this.isSP = type;
    this.unit = 100;
    this.canvas;
    this.context;
    this.canvas2;
    this.context2;
    this.width;
    this.height;
    this.xAxis;
    this.yAxis;
    this.draw = {
      seconds: 0,
      t: 0,
    };

    this.init();

  }



  init() {
    console.log(Number($('#js-philo-wave').css('paddingTop').replace('px', '')))
    this.canvas = document.getElementById("sineCanvas");
    
    this.canvas.width = document.documentElement.clientWidth; //Canvasのwidthをウィンドウの幅に合わせる
    this.canvas.height = this.isSP ? 70 : 100;
    
    this.context = this.canvas.getContext("2d");
    this.height = this.canvas.height;
    this.width = this.canvas.width;
    
    this.xAxis = Math.floor(this.height/2);
    this.yAxis = 0;
    
    this.render();
  }

    
  render() {
      
      // キャンバスの描画をクリア
      this.context.clearRect(0, 0, this.width, this.height);

      //波を描画
      this.drawWave('#fff', 1, 3, 1);
      
      // Update the time and draw again
      this.draw.seconds = this.draw.seconds + .009;
      this.draw.t = this.draw.seconds*Math.PI;
      setTimeout(() => {this.render()}, 35);
  }




  /**
  * 波を描画
  * drawWave(色, 不透明度, 波の幅のzoom, 波の開始位置の遅れ)
  */
  drawWave(color, alpha, zoom, delay) {
      this.context.fillStyle = color;
      this.context.globalAlpha = alpha;

      this.context.beginPath(); //パスの開始
      this.drawSine(this.draw.t / 0.5, zoom, delay);
      this.context.lineTo(this.width + 10, this.height); //パスをCanvasの右下へ
      this.context.lineTo(0, this.height); //パスをCanvasの左下へ
      this.context.closePath() //パスを閉じる
      this.context.fill(); //塗りつぶす
  }

    /**
     * Function to draw sine
     * 
     * The sine curve is drawn in 10px segments starting at the origin. 
     * drawSine(時間, 波の幅のzoom, 波の開始位置の遅れ)
     */
  drawSine(t, zoom, delay) {

        // Set the initial x and y, starting at 0,0 and translating to the origin on
        // the canvas.
        var x = t; //時間を横の位置とする
        var y = Math.sin(x)/zoom;
        this.context.moveTo(this.yAxis, this.unit*y+this.xAxis); //スタート位置にパスを置く
        
        // Loop to draw segments (横幅の分、波を描画)
        for (var i = this.yAxis; i <= this.width + 10; i += 10) {
            x = t+(-this.yAxis+i)/this.unit/zoom;
            y = Math.sin(x - delay)/3;
            this.context.lineTo(i, this.unit*y+this.xAxis);
        }
    }

}



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/utill/wave.js
 **/